const fruits = [
    'Pomme',
    'Poire',
    'Banane',
    'Orange',
    'Mandarine',
    'Clémentine',
    'Fraise',
    'Framboise',
    'Myrtille',
    'Mûre',
    'Cerise',
    'Mangue',
    'Papaye',
    'Pastèque',
    'Prune',
    'Pêche',
    'Nectarine',
    'Figue',
    'Grenade',
    // 'Litchi',
    // 'Citron',
    // 'Pamplemousse',
    // 'Raisin',
    // 'Kiwi',
    // 'Ananas',
    // 'Melon',
    // 'Abricot',
    // 'Kaki',
];

const adjectifs = [
    'Farfelue',
    'Loufoque',
    'Cocasse',
    'Dingo',
    'Ébouriffée',
    'Bidonnante',
    'Épatante',
    'Zinzibule',
    'Rigolarde',
    'Grognonne',
    'Chiffonnée',
    'Tordante',
    'Saugrenue',
    'Chouettissime',
    'Pétillante',
    'Déjantée',
    'Givrée',
    'Burlesque',
    'Ébouriffante',
    'Tintinnabulante',
    'Incroustible',
    'Délirante',
    'Bidouilleuse',
];

export function generateFruityUsername() {
    const fruit = fruits[Math.floor(Math.random() * fruits.length)];
    const adjectif = adjectifs[Math.floor(Math.random() * adjectifs.length)];
    return `${fruit} ${adjectif}`;
}
